import { BaseTool } from '../BaseTool';

export class ProjectUnitsTool extends BaseTool {
    id = 'MANAGE_UNITS';
    name = 'Project Units';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openManageDialog('units');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
